/**
 * @ngdoc services
 * @memberof mercury.services
 * @name shiftHelpers
 * @description Service to hold reusable shift helper functions
 */

angular.module('mercury.services.helperUtils')
.factory('shiftHelpers', function() {

  /**
   * Returns the unpaid break duration for a given shift
   *
   * @param breakEnd the end time of the break
   * @param breakStart the start time of the break
   * @returns
   */
  function calculateBreakDuration(breakStart, breakEnd) {
    var unpaidBreakDuration = 0;
    if (!breakStart || !breakEnd) {
      return 0;
    }
    // Calculate the total unpaid break duration using the helper function
    unpaidBreakDuration = moment(breakEnd).diff(moment(breakStart), 'minutes');
    return unpaidBreakDuration;
  }

  /**
   * Returns the total unpaid break duration for a given shift
   *
   * @param shift a shiftDTO object
   * @returns
   */
  function calculateTotalUnpaidBreakDuration(shift) {
    var totalUnpaidBreakDuration = 0;
    angular.forEach(shift.breaks, function(breakObj) {
      if (!breakObj.paid) {
        totalUnpaidBreakDuration += moment(breakObj.breakEnd).diff(moment(breakObj.breakStart), 'minutes') / 60;
      }
    });
    return totalUnpaidBreakDuration;
  }

  return {
    calculateTotalUnpaidBreakDuration: calculateTotalUnpaidBreakDuration,
    calculateBreakDuration: calculateBreakDuration,
  };
});
